<template>
  <div v-if="is_load">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Главная</a></li>

        <li class="breadcrumb-item active" aria-current="page">{{ service.name}}</li>
      </ol>
    </nav>

    <section class="section section-lg">
      <div class="container">




        <div class="  row row-grid align-items-center"           >
          <div class="col-md-6 order-md-2">
            <img :src="image_url+service.image" class="img-fluid floating">
          </div>
          <div class="col-md-6 order-md-1">
            <h2>{{ service.name }}</h2>
            <div class="pr-md-5" v-html="service.content">

            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section section-shaped my-0 overflow-hidden content_background_color_blue2">
      <div class="shape shape-style-1 bg-gradient-warning ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </div>

      <div class="container py-0 ">
        <div class="row row-grid mb-5 align-items-center">
          <div class="d-flex px-3">
            <div>
              <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                    rounded></icon>
            </div>
            <div class="pl-4">
              <h4 class="display-3 text-white">Примеры работ</h4>


            </div>
          </div>

          <div class="row col-md-12 mt-3" v-if="works.length>0">
            <router-link v-for="work in works" :key="work.last_id"
                         v-if="works.length>0"
                         :to="{name: 'workpage', params: { username: work.user.username,work_id:work.last_id }}">
              <sui-card class="col-md-3 m-2">
                <a href="#">

                  <sui-image :src="work.image"/>
                </a>
                <sui-card-content>
                  <sui-card-header><a>{{ work.name }}</a></sui-card-header>
                  <sui-card-meta>
                    <a>{{ work.date_start }}-{{ work.date_end }}</a>
                    <a>{{ work.category.name }}</a>
                  </sui-card-meta>
                </sui-card-content>
              </sui-card>
            </router-link>


          </div>


        </div>
      </div>
    </section>
    <section class="section section-shaped my-0 overflow-hidden ">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Схема работы</h2>
            <p class="lead text-white">Следуйте простым шагам и вы достигните результата</p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <sui-step-group size="mini">
            <a is="sui-step" :active="true" icon="cart plus">
              <sui-step-content
                  title="Опубликуйте заказ"
                  description="Первый шаг к новым ощущениям"

              />
            </a>
            <a is="sui-step" icon="shopping cart">
              <sui-step-content
                  title="Оценка проекта"
                  description="Процесс оценки вашего проекта по ТЗ"

              />
            </a>

            <a is="sui-step" icon="handshake outline">
              <sui-step-content
                  title="Проект в работе"
                  description="Плодотворная работа в самом разгаре"
              />
            </a>
            <a is="sui-step" icon="thumbs up outline">
              <sui-step-content
                  title="Проект завершен"
                  description="Только после завершения и полной проверки проекта вы платите деньги."
              />
            </a>
          </sui-step-group>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Готовы к продуктивной работе?</h4>


              <div class="row">
                <base-button class="ml-3" type="primary" @click="callModalAddProject">
                  Рассказать о проекте <i class="fa fa-plus-circle"></i>
                </base-button>

              </div>


            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";
import {eventBus} from "../../main";




var Avatar = require('vue-avatar');


export default {
  name: 'home',

  components: {},
  data() {
    return {
      "service":null,
      "works":[],
      "is_load":false,
      "image_url":null,
    }
  },
  mounted() {
    var service_id=this.$route.params.service_id;
    var app=this;

    Api.loadAboutService(service_id,function(data){
      app.image_url = Vue.config.IMAGE_URL;
      app.service=data.service;
      app.works=data.works;
      app.is_load=true;
    })
  },
  methods: {
    callModalAddProject() {
      var app=this;
      eventBus.$emit("call_modal_add_project", {'current_form_category':app.service.last_id})
      {

      }
    },




  }
};
</script>
